<template>

	<div

		class="g-block-body-notice-box g-block-body-padding"

		:class="{

			'g-block-body-notice-box--edit': editable,

			'is-active': editable && active,

			'g-block-body-notice-box--h5': h5,

			'g-block-body-padding--h5': h5,

		}"

		@click="onWrapClick"

	>

		<div class="g-block-body-notice-box__shell">

			<div class="g-block-body-notice-box__title-wrap">

				<div

					class="g-block-body-notice-box__title-mask"

					:style="{ background: panelBackground }"

				>

					<div

						class="g-block-body-notice-box__title-box"

						:style="{ borderColor: themeColor, color: themeColor, background: panelBackground }"

					>

						<RichTextEditable

							v-if="editable"

							class="g-block-body-notice-box__title"

							fit-content

							:model-value="data.title"

							placeholder="请输入标题"

							@update:model-value="onTitleUpdate"

							@focus="onWrapClick"

						/>

						<div

							v-else

							class="g-block-body-notice-box__title"

							v-html="data.title || ''"

						></div>

					</div>

				</div>

			</div>

			<div

				class="g-block-body-notice-box__frame"

				:style="{ borderColor: themeColor, background: panelBackground }"

			>

				<RichTextEditable

					v-if="editable"

					class="g-block-body-notice-box__text"

					:style="{ color: themeColor }"

					:model-value="data.content"

					placeholder="请输入正文"

					@update:model-value="onContentUpdate"

					@focus="onWrapClick"

				/>

				<div

					v-else

					class="g-block-body-notice-box__text"

					:style="{ color: themeColor }"

					v-html="data.content || ''"

				></div>

			</div>

		</div>

	</div>

</template>



<script>

	import RichTextEditable from '../../../components/RichTextEditable.vue';

	import { lightenHexColor } from '../../../utils/richText.js';

	import { bodyCardMixin } from '../shared/bodyCardMixin.js';



	export default {

		name: 'GBlockBodyNoticeBox',

		components: { RichTextEditable },

		mixins: [bodyCardMixin],

		computed: {

			panelBackground() {

				return lightenHexColor(this.themeColor, 0.93);

			},

		},

	};

</script>



<style scoped lang="less">

	@import '../shared/bodyEditShell.less';



	@title-overlap: 12px;



	.g-block-body-notice-box {

		.body-block-edit-shell();

	}



	.g-block-body-notice-box__shell {

		display: flex;

		flex-direction: column;

		align-items: stretch;

	}



	.g-block-body-notice-box__title-wrap {

		position: relative;

		z-index: 1;

		display: flex;

		justify-content: center;

		margin-bottom: -@title-overlap;

	}



	.g-block-body-notice-box__title-mask {

		display: inline-flex;

		max-width: calc(100% - 24px);


		line-height: 0;

		box-sizing: border-box;

	}



	.g-block-body-notice-box__title-box {

		padding: 2px 12px;

		border: 1px solid;

		line-height: normal;

		box-sizing: border-box;

	}



	.g-block-body-notice-box__title {

		.body-title-base();

		font-size: 15px;

		text-align: center;

		white-space: nowrap;



		:deep(.g-rich-text-editable__content) {

			text-align: center;

			white-space: nowrap;

		}

	}



	.g-block-body-notice-box__frame {

		border: 1px solid;

		border-radius: 4px;

		padding: calc(@title-overlap + 6px) 14px 14px;

		box-sizing: border-box;

	}



	.g-block-body-notice-box__text {

		.body-text-base();

		font-weight: 400;

	}



	.g-block-body-notice-box--h5 {

		@title-overlap-h5: 0.24rem;



		.g-block-body-notice-box__title-wrap {

			margin-bottom: calc(-1 * @title-overlap-h5);

		}



		.g-block-body-notice-box__title-mask {

			max-width: calc(100% - 0.48rem);

			padding: 0 0.2rem;

		}



		.g-block-body-notice-box__title-box {

			padding: 0.04rem 0.24rem;

		}



		.g-block-body-notice-box__title {

			font-size: 0.3rem;

		}



		.g-block-body-notice-box__frame {

			border-radius: 0.08rem;

			padding: calc(@title-overlap-h5 + 0.12rem) 0.28rem 0.28rem;

		}



		.body-text-base--h5(~'.g-block-body-notice-box__text');

	}

</style>


